import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { handleError } from '../../../helpers/handle-error';
import {
  getConnectedCompanyIntegrationsAction,
  getConnectedCompanyIntegrationsFailureAction,
  getConnectedCompanyIntegrationsSuccessAction,
} from './get-connected-company-integrations.actions';
import { GetConnectedCompanyIntegrationsService } from './get-connected-company-integrations.service';

@Injectable()
export class GetConnectedCompanyIntegrationsEffects {
  private readonly actions$ = inject(Actions);
  private readonly getConnectedCompanyIntegrationsService = inject(GetConnectedCompanyIntegrationsService);
  private readonly notifyService = inject(ToastrService);

  getConnectedCompanyIntegrations$ = createEffect(() => this.actions$.pipe(
    ofType(getConnectedCompanyIntegrationsAction),
    switchMap(() => this.getConnectedCompanyIntegrationsService.get().pipe(
      map(data => getConnectedCompanyIntegrationsSuccessAction({ data })),
      catchError(error => of(getConnectedCompanyIntegrationsFailureAction({ error }))),
    )),
  ));

  getConnectedCompanyIntegrationsFailure$ = createEffect(() => this.actions$.pipe(
    ofType(getConnectedCompanyIntegrationsFailureAction),
    tap(action => handleError(action.error, 'Failed to get connected integrations', this.notifyService)),
  ), { dispatch: false });
}
